export default function jsonformatter(input){
    return JSON.stringify(JSON.parse(input),null,2);
    
    }